import { motion } from "framer-motion";
import { STATS } from "@/data/site";

export default function Stats() {
  return (
    <section className="relative bg-[#050505] py-16" data-testid="stats">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid grid-cols-2 gap-px overflow-hidden border border-white/10 bg-white/10 md:grid-cols-4">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-[#050505] p-8 text-center sm:p-10"
            >
              <div className="font-heading text-5xl font-black text-volt sm:text-6xl">{s.value}</div>
              <div className="mt-2 font-body text-xs font-semibold uppercase tracking-[0.15em] text-neutral-400">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
